var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',_vm._g(_vm._b({staticClass:"app-tooltip"},'tooltip',_vm.props,false),_vm.handlers))
}
var staticRenderFns = []

export { render, staticRenderFns }